/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */
import * as React from 'react';
import * as Mui from 'mui';

import constants from 'app/constants';
import { Loading } from '../loading';
import { AppRoot } from './appRoot';
import { AppEventsContextProvider, AppEvents } from 'contexts/appEventsContext';

interface AppLoaderState {
  ready: boolean;
  events: AppEvents;
}


/** AppLoader */
export class AppLoader extends React.Component<{}, AppLoaderState> {
  constructor(props: {}, ctx: any) {
    super(props, ctx);
    this.state = {
      ready: false,
      events: new AppEvents(),
    };
  }

  componentDidMount() {
    this.setState({ ready: true });
  }

  render() {

    let component: React.ComponentClass = Loading;
    if (!this.state.ready) {
      window.document.title = constants.title;
    }
    else if (this.state.ready) {
      component = AppRoot;
      window.document.body.classList.add('loaded');
    }

    return (
      <AppEventsContextProvider value={this.state.events}>
        <Mui.CssBaseline />
        <Mui.MuiThemeProvider theme={Mui.MuiTheme} >
          {React.createFactory<any>(component)({ events: this.state.events })}
        </Mui.MuiThemeProvider>
      </AppEventsContextProvider>
    );
  }
}

export default AppLoader;



// WEBPACK FOOTER //
// ./src/views/appLoader/index.tsx